var render, staticRenderFns
import script from "./changeMonitor.vue?vue&type=script&lang=js&"
export * from "./changeMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56cdcd",
  null
  
)

export default component.exports